import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.timers.js";
// Constants
import constants from "./constants/tracking.constants";
// Translations
import translations from "./translations/tracking.translations";
// Types

var currentPageDisplayed = '';
var startAttempts = 0;
var trackViewEventType = function trackViewEventType(payload) {
  if ((payload === null || payload === void 0 ? void 0 : payload.pageName) !== currentPageDisplayed) {
    var _window, _window$utag;
    currentPageDisplayed = payload === null || payload === void 0 ? void 0 : payload.pageName;
    (_window = window) === null || _window === void 0 ? void 0 : (_window$utag = _window.utag) === null || _window$utag === void 0 ? void 0 : _window$utag.view(payload);
  } else window.console.warn(translations.EXCEPTION_SAME_PAGE_TRACKED);
};
var trackLinkEventType = function trackLinkEventType(payload) {
  var _window2, _window2$utag;
  return (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$utag = _window2.utag) === null || _window2$utag === void 0 ? void 0 : _window2$utag.link(_objectSpread(_objectSpread({}, payload), {}, {
    eventCategory: currentPageDisplayed
  }));
};
var dispatchEvent = function dispatchEvent(_ref) {
  var type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case constants.TRACK_TYPES.VIEW:
      trackViewEventType(payload);
      break;
    case constants.TRACK_TYPES.LINK:
      trackLinkEventType(payload);
      break;
  }
};
var isValidSetup = function isValidSetup(_ref2) {
  var payload = _ref2.payload,
    type = _ref2.type;
  return type && payload && constants.COMMON_KEYS.every(function (k) {
    return payload[k];
  });
};
var checkToSetupWindowTools = function checkToSetupWindowTools(action) {
  if (startAttempts === constants.MAX_ATTEMPTS) {
    return window.console.error(translations.EXCEPTION_INIT);
  } else {
    startAttempts = startAttempts + 1;
    setTimeout(function () {
      return track(action);
    }, constants.TIME_TO_RETRY); // We delay next attempt
  }
};
var checkActionAndDispatchEvent = function checkActionAndDispatchEvent(action) {
  if (!isValidSetup(action)) {
    window.console.error(translations.EXCEPTION_BAD_REQUEST);
  } else {
    dispatchEvent(action);
  }
};
var track = function track(action) {
  if (!window.utag) {
    checkToSetupWindowTools(action);
  } else {
    checkActionAndDispatchEvent(action);
  }
};
export default {
  track: track,
  eventTypes: constants.TRACK_TYPES,
  pageTypes: constants.PAGE_TYPES
};
export * from "./types/tracking-action.type";
export * from "./types/tracking-payload.type";